<template>
	<div>
		<div v-if="list.length != 0">
			<ul class="mt20 workuls">
				<li :class="[listNum==3?'three':'four']" v-for="(item,index) in list" :key="index"
					@click="toDetails(item)">
					<div v-if="showMore">
						<div class="more" v-if="index !=moreStatic" @click.stop="dianClick(index)">
							<i class="el-icon-more"></i>
						</div>
						<div class="more s" v-else @mouseleave="moreStatic = -1">
							<div>
								<i class="el-icon-edit" @click.stop="moreEditClick(item,1)"></i>
							</div>

							<div>
								<i class="el-icon-delete" @click.stop="moreEditClick(item.eventOperaWorkId,2,index)"></i>
							</div>
						</div>
					</div>
					<el-image fit="cover" :src="item.picture" />
					<div class="listcon">
						<div class="worltitle">{{item.title}}</div>
						<div class="is-flex flexween is-center">
							<el-tag effect="plain" size="mini" :type="item.track ==2?'warning':'error'">
								{{item.dictLabel}}
							</el-tag>
							<div class="htime">
								{{item.createTime | dateFormat}}
							</div>
						</div>
						
					</div>
				</li>
			</ul>
		</div>
		<div v-else>
			<h2>暂无作品</h2>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'worklist',
		components: {},
		props: {
			showMore: {
				default: true,
				type: Boolean
			},
			listNum: {
				default: 3,
				type: [
					Number, String
				]
			},
			list: {
				type: Array,
				default: () => []
			}
		},
		data() {
			return {
				moreStatic: -1,
			}
		},
		created() {},
		methods: {

			dianClick(index) {
				this.moreStatic = index
			},
			moreEditClick(data, e, index) {
				this.$emit('iconClick', {
					data,
					e,
					index
				})
			},
			toDetails(item) {
				this.$emit('toDetails', item)
			}
		}
	}
</script>

<style lang="scss" scoped>
	.userradio {
		position: absolute;
		left: 10px;
		top: 10px;
		z-index: 1;

		/deep/ .el-checkbox__inner {
			width: 20px;
			height: 20px;
			font-size: 24px;
		}

		/deep/ .el-checkbox__inner::after {
			height: 11px;
			left: 5px;
			width: 5px;
		}
	}

	.workuls {
		li.four {
			margin-right: 2%;
			width: 23.5%;
		}

		li.four:nth-child(4n) {
			margin-right: 0;
		}

		li.three {
			margin-right: 2%;
			width: 32%;
		}

		li.three:nth-child(3n) {
			margin-right: 0;
		}

		li {
			float: left;
			margin-bottom: 2%;
			background-color: white;
			border-radius: 10px;
			overflow: hidden;
			position: relative;

			.more {
				position: absolute;
				width: 30px;
				z-index: 1;
				border-radius: 6px;
				background-color: var(--white);
				top: 10px;
				right: 10px;

				i {
					display: block;
					font-size: 18px;
					padding: 6px 0;
					text-align: center;
					color: var(--info);
					cursor: pointer;

					&:hover {
						color: var(--brand);
					}
				}

			}

			.more.s {
				padding: 3px 0;
			}

			.el-image {
				height: 240px;
			}

			.listcon {
				padding: 14px;

				.sp {
					text-overflow: ellipsis;

					display: -webkit-box;
					-webkit-line-clamp: 1;
					-webkit-box-orient: vertical;

					display: -moz-box;
					-moz-line-clamp: 1;
					-moz-box-orient: vertical;

					overflow-wrap: break-word;
					word-break: break-all;
					white-space: normal;
					overflow: hidden;
				}

				.tipsspan {
					color: var(--info);
					display: inline-block;
					margin-right: 10px;
					margin-bottom: 4px;
				}

				.el-tag {
					margin-right: 8px;
					border-radius: 10px !important;
				}

				.worltitle {
					font-weight: bold;
					margin: 0 0 10px 0;
					font-size: 16px;
					text-overflow: ellipsis;
					white-space: normal;
					overflow: hidden;

				}



				.htime {
					color: var(--info);
				}
			}
		}




	}

	.workuls:after {
		content: '';
		display: block;
		clear: both;
		visibility: hidden;
	}

	/deep/ .el-pager li,
	/deep/ .el-pagination .btn-prev,
	/deep/ .el-pagination .btn-next,
	/deep/ .el-input__inner {
		background-color: transparent !important
	}
</style>
